<template>
  <span class="icomoon"
        :class="[fixedWidthClass, iconClass, clickableClass, sizeClass, spinningClass]"
        :title="title"
        @click="$emit('click', $event)">
    <template v-if="multilayer">
      <span class="path1"></span>
      <span class="path2"></span>
    </template>
  </span>
</template>

<script>
  import BootstrapVariant from '@vendor/bootstrap/BootstrapVariant';

  /**
   * @deprecated Discuss with the UX team and use the component/service from `@meteocontrol/vue-components` instead
   * @see https://confluence.meteocontrol.de/x/W0G8Dw
   */
  export default {
    name: 'Icon',
    compatConfig: {
      MODE: 3,
    },
    props: {
      name: {
        required: true,
        type: String,
        validator: (value) => /^([a-z0-9-]+)$/gi.test(value),
      },
      title: {
        required: true,
        type: String,
      },
      fixedWidth: {
        type: Boolean,
        default: false,
      },
      clickable: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      spinning: {
        type: Boolean,
        default: false,
      },
      multilayer: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['click'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    computed: {
      iconClass() {
        return `icon-${this.name}`;
      },
      fixedWidthClass() {
        return this.fixedWidth ? 'icomoon-fw' : '';
      },
      clickableClass() {
        return this.clickable ? 'clickable' : '';
      },
      sizeClass() {
        const mapSizeToClass = {
          [BootstrapVariant.MEDIUM]: 'icomoon-md',
          [BootstrapVariant.LARGE]: 'icomoon-lg',
          [BootstrapVariant.XLARGE]: 'icomoon-2x',
        };
        return mapSizeToClass[this.size] ?? '';
      },
      spinningClass() {
        return this.spinning ? 'icomoon-spin' : '';
      },
    },
  };
</script>

<style scoped>
  .icomoon {
    position: relative;
    top: 1px;
  }
</style>
